// removed by extract-text-webpack-plugin
module.exports = {"heading":"SwimmySectionPress__heading__2rCgL","link":"SwimmySectionPress__link__1PpaS","linkImageWrapper":"SwimmySectionPress__linkImageWrapper__9X1GV","linkImage":"SwimmySectionPress__linkImage__debMZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SwimmySectionPress/SwimmySectionPress.css
// module id = 2121
// module chunks = 0